import { Component, ChangeDetectionStrategy, HostBinding,
    ViewEncapsulation, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { consumeEvent } from '@eui/core';

import { BaseDirective } from '../../base.directive';
import { EuiMenuItem } from './models/eui-menu-item.model';

@Component({
    selector: 'eui-menu-item',
    templateUrl: './eui-menu-item.component.html',
    styleUrls: ['./styles/_index.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiMenuItemComponent extends BaseDirective {

    @Input() item: EuiMenuItem;
    @Input() hasIcon: boolean = false;
    @Input() hasTooltip: boolean = false;
    @Input() isCollapsed: boolean = false;

    @Output() expandToggled = new EventEmitter<EuiMenuItem>();
    @Output() clicked = new EventEmitter<EuiMenuItem>();

    externalLinkLabel = 'external link';
    expandMenuLabel = 'Expand';
    collapseMenuLabel = 'Collapse';

    constructor(
    ) {
        super();
    }

    @HostBinding('class')
    get cssClasses() {
        return [
            super.getCssClasses('eui-menu-item'),
        ].join(' ').trim();
    }

    @HostListener('click', ['$event'])
    stopPropagation(event: MouseEvent) {
        event.stopPropagation();
    }

    public onClick(event: any) {
        this.clicked.emit(this.item);
        consumeEvent(event);
    }

    public onExpandToggle(event: any) {
        this.expandToggled.emit(this.item);
        consumeEvent(event);
    }
}
